/**
 * Script to be added to the Contact Us page before the </body> tag.
 *
 * Example,
 * <script async src="UPLOADED SCRIPT URL HERE"></script>
 */

import { type SchemaForFormType } from "@pph-webflow/contact-form-handler";

import {
  DEFAULT_FORM_NAME_KEY,
  DEFAULT_NEXT_URL_KEY,
  attachToForm,
} from "../../common/contactForm";
import { hub } from "../../common/sentry";
import { getCurrentUrl } from "../../common/utils/url";

const CURRENT_URL = getCurrentUrl();

// Runs after document is loaded
$(() => {
  const formType = "sign-up";
  const defaultFormValues = {
    [DEFAULT_FORM_NAME_KEY]: "Contact Us",
    [DEFAULT_NEXT_URL_KEY]: CURRENT_URL,
    interestedParty: "Myself",
  } satisfies Partial<SchemaForFormType<typeof formType>>;

  hub.setContext("form", {
    formType,
    ...defaultFormValues,
  });

  attachToForm(formType, { defaultFormValues });
});
